import { zodResolver } from '@hookform/resolvers/zod';
import { TextField } from '@mui/material';
import type { TriggerCustomersReportJobParameters } from '@vy/api-definition';
import { TriggerCustomersReportJobParametersSchema } from '@vy/api-definition';
import { REPORT_JOB_TYPES } from '@vy/types';
import { FormProvider, useForm } from 'react-hook-form';
import type { TriggerReportJobFormProps } from '../TriggerReportJobDialog';

export const TriggerCustomersReportJobForm: React.FC<TriggerReportJobFormProps> = ({
  onSubmit,
  dialogActions,
}) => {
  const methods = useForm<TriggerCustomersReportJobParameters>({
    resolver: zodResolver(TriggerCustomersReportJobParametersSchema),
    defaultValues: {
      reportJobType: REPORT_JOB_TYPES.Customers,
    },
  });

  const reportNameRegister = methods.register('reportName');
  const handleSubmit = methods.handleSubmit((data) => onSubmit(data));

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit}>
        <div className="mt-3 flex flex-col items-start">
          <TextField {...reportNameRegister} className="w-full" placeholder="Report name" />
        </div>
        {dialogActions}
      </form>
    </FormProvider>
  );
};
